
<div class="modal-header">
  <h4 class="modal-title">{{ "general.sessionTimeout.header" | translate }}</h4>
  <button (click)="close()" aria-label="Close" class="btn-close modalX" type="button"></button>
</div>
<div class="modal-body">
  <span>{{ "general.sessionTimeout.body" | translate }}</span>
</div>
<div class="modal-footer">
  <div class="btnSet">
    <div>
      <button (click)="close()" class="btn primary" type="button">{{ "general.label.button.ok" | translate }}</button>
    </div>
  </div>
</div>
